module.exports = __webpack_public_path__ + "static/assets/6e620373b3714f590d9888401da0b2e0.png";